module.exports = __webpack_public_path__ + "static/media/Badge_Dermatologie.6c0cf187.png";